import PurchaseOrderView from './PurchaseOrderView';

export default PurchaseOrderView;
